import { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { matchRoles } from '@utils/matchRoles';
import { selectUser } from '@state/selectors';
import history from '@lib/history';

const usePermissions = (
  permissions,
  redirect = false,
  redirectLocation = '',
) => {
  const user = useSelector(selectUser);
  const [matchingPermission, setMatchingPermission] = useState('');
  useEffect(() => {
    if (!user) {
      history.location.replace('/');
    }

    const match = matchRoles(permissions, user.permissions);

    if (!match && redirect) {
      redirectLocation.length > 0
        ? history.replace(redirectLocation)
        : history.replace('/');
    }

    setMatchingPermission(match);
  }, [setMatchingPermission, permissions, user, redirect, redirectLocation]);

  return matchingPermission;
};

export default usePermissions;

// DESCRIPTION:
// hook that returns the first matching permission of the authenticated user
// params:
// - list of permissions
// - optional: redirect - if true and no permissions were found within the passed ones, it will redirect to /
// returns:
// - the matching permission as a string

// USAGE:
// for example:
// Inverse
// users with the permission of !manage_workflows cannot see workflows:
// const permission = usePermissions(['!manage_workflows'], true);
// permission will be undefined if user can manage workflows else will be '!manage_workflows' if user cannot manage workflows

// Not Inverse
// for example: users with the permission of update_session can update session or engage with user on agent room:
// const permission = usePermissions(['update_session'], true);
// permission will be 'update_session' if user has permission to update session else it will be undefined
